import React,{useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import plus_white from "../../../assets/icons/plus_white.svg";
import { useNavigate } from "react-router-dom";
// Components
import Header from "../../../components/Header";
import { CardWithoutSeeMore } from "../../../components/Cards";
import StoresTable from "../../../tables/StoreManagement/StoresTable";
import { getAllStoresStats } from "../../../redux/StoreManagement/storeManagementActions";

const AllStores = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
  const { 
    storesStats
  } = useSelector((state) => state.storeManagement);


useEffect(()=>{
  dispatch(getAllStoresStats());
},[dispatch])

  return (
    <>
      {/* Page Header */}
     <Header text="All Stores">
        <button
      onClick={() => navigate('/store-management')}
        className="w-full py-3 flex items-center justify-center px-4 bg-[#2B8C34] rounded-[8px] text-white hover:text-white text-sm font-medium  hover:bg-[#24752B] transition-all"
      >
        <img src={plus_white} alt="plus icon" />
        <p className="text-white font-medium text-sm ml-2">Add Store</p>
      </button>
      </Header>

      {/* Stats Cards Section */}
      <div className="grid grid-cols-4 gap-4 mt-6">
        <CardWithoutSeeMore
          title="Total Stores"
          subtitle={storesStats?.total_stores?.toLocaleString() || 0}
          description="Total number of stores in the system"
        />
        
        <CardWithoutSeeMore
          title="Active Stores"
          subtitle={storesStats?.active_stores?.toLocaleString() || 0}
          description="Currently operational stores"
        />
        
        <CardWithoutSeeMore
          title="Inactive Stores"
          subtitle={storesStats?.inactive_stores?.toLocaleString() || 0}
          color="border-l-[#EF4444]"
          hasStatus
          status="Inactive"
          description="Stores that are not operational"
        />

        <CardWithoutSeeMore
          title="Total Stock Value"
          subtitle={`₦${storesStats?.total_stock_value?.toLocaleString() || 0}`}
          description="Combined value of all store inventory"
        />
      </div>

      {/* Stores Table */}
      <div className="mt-6">
        <StoresTable />
      </div>
    </>
  );
};

export default AllStores;
